export enum EPersonId {
    MatheusAlexandre = "alexandre1",
    EllyGriffin = "griffin1",
    JessicaLin = "lin1",
    ChrisKukk = "kukk1",
    KrishanSingh = "singh1",
    CoryPineau = "pineau1",
    StephenAlpuche = "alpuche1",
    WilliamJoel = "joel1",
    TyDoris = "doris1",
    DanielCoffman ="coffman1",
    JonathanMiddleton = "middleton1",
    ChristopherIossa = "iossa1",
}